import React, { useContext, useMemo } from 'react';
import { StaticContext } from '@sm/webassets';

import HelmetWithChildren from '~pricing/lib/HelmetWrapper';
import { SeoHeadTags, HrefLangsTags } from '~pricing/components/SEO';

import { getLinks } from './links';
import { SeoProps, Links } from './types';

export default function Seo({ canonicalPath = '', noIndex = false, children }: SeoProps): JSX.Element {
  const {
    environment: { domain },
    req: { hostname },
    url,
  } = useContext(StaticContext);

  const path = canonicalPath || url;
  const hrefLangs = useMemo(() => getLinks(domain, path) as Links[], [domain, path]);
  return (
    <>
      <HelmetWithChildren>
        {/*
          these need to be referenced as function calls because of Helmet's requirements for children:
          https://github.com/nfl/react-helmet/issues/326
        */}

        {SeoHeadTags()}
        {/* Don't allow this page to be indexed by search engines, should happen after title has been generated */}
        <If condition={noIndex}>
          {/* https://developers.google.com/search/docs/crawling-indexing/block-indexing?hl=en&sjid=6366088352522703778-NC&visit_id=638453660902171326-2338794797&rd=1 */}
          <meta data-testid="SEO__NoIndex" name="robots" content="noindex, nofollow" />
        </If>
        {HrefLangsTags({ hrefLangs, hostname, path })}
      </HelmetWithChildren>
      {children}
    </>
  );
}
